module.exports = __webpack_public_path__ + "img/v_solvo.e6c421c8.svg";